import {
  siAppsmith, siBookstack, siDirectus, siDiscourse, siDolibarr, siDrupal, siErpnext, siForgejo, siFreshrss, siGhost, siGitea, siGrav, siInvoiceninja, siLimesurvey, siListmonk, siMatomo, siMautic, siModx, siMoodle, siN8n, siNextcloud, siNodebb, siOctobercms, siOdoo, siOnlyoffice, siOwncloud, siPhpbb, siPiwigo, siPlausibleanalytics, siPrestashop, siRoundcube, siSeafile, siShopware, siStrapi, siTypo3, siUmami, siUptimekuma, siWallabag, siWikidotjs, siJoomla, siWoocommerce, siWordpress,
  type SimpleIcon,
} from "simple-icons";
import { cn } from "./cn";

/** Brand marks (Simple Icons, CC0) for App Installer catalog entries, by the recipe's `logo` slug. */
const APP_ICONS: Record<string, SimpleIcon> = {
  appsmith: siAppsmith,
  bookstack: siBookstack,
  directus: siDirectus,
  discourse: siDiscourse,
  dolibarr: siDolibarr,
  drupal: siDrupal,
  erpnext: siErpnext,
  forgejo: siForgejo,
  freshrss: siFreshrss,
  ghost: siGhost,
  gitea: siGitea,
  grav: siGrav,
  invoiceninja: siInvoiceninja,
  limesurvey: siLimesurvey,
  listmonk: siListmonk,
  matomo: siMatomo,
  mautic: siMautic,
  modx: siModx,
  moodle: siMoodle,
  n8n: siN8n,
  nextcloud: siNextcloud,
  nodebb: siNodebb,
  octobercms: siOctobercms,
  odoo: siOdoo,
  onlyoffice: siOnlyoffice,
  owncloud: siOwncloud,
  phpbb: siPhpbb,
  piwigo: siPiwigo,
  plausibleanalytics: siPlausibleanalytics,
  prestashop: siPrestashop,
  roundcube: siRoundcube,
  seafile: siSeafile,
  shopware: siShopware,
  strapi: siStrapi,
  typo3: siTypo3,
  umami: siUmami,
  uptimekuma: siUptimekuma,
  wallabag: siWallabag,
  wikidotjs: siWikidotjs,
  joomla: siJoomla,
  woocommerce: siWoocommerce,
  wordpress: siWordpress,
};

const BOX = { sm: "h-9 w-9 rounded-lg text-[12px]", md: "h-11 w-11 rounded-xl text-[13px]", lg: "h-14 w-14 rounded-2xl text-[16px]" } as const;
const GLYPH = { sm: 18, md: 22, lg: 28 } as const;

/** An App Installer catalog app's logo on a soft brand-tinted tile; apps without a mark get their initials. */
export function CatalogAppLogo({ logo, name, size = "md", className }: { logo: string | null | undefined; name: string; size?: keyof typeof BOX; className?: string }) {
  const icon = logo ? APP_ICONS[logo] : undefined;
  if (!icon) {
    const initials = name.replace(/[^A-Za-z0-9 ]/g, "").split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]!.toUpperCase()).join("") || "?";
    return <span aria-hidden className={cn("flex shrink-0 items-center justify-center bg-accent-soft font-semibold text-accent", BOX[size], className)}>{initials}</span>;
  }
  const hex = `#${icon.hex}`;
  // Very dark marks are drawn in the foreground colour so they stay visible in dark mode.
  const dark = parseInt(icon.hex.slice(0, 2), 16) + parseInt(icon.hex.slice(2, 4), 16) + parseInt(icon.hex.slice(4, 6), 16) < 150;
  return (
    <span
      aria-hidden
      className={cn("flex shrink-0 items-center justify-center border border-line bg-[color-mix(in_srgb,var(--app)_10%,transparent)]", BOX[size], className)}
      style={{ "--app": hex } as React.CSSProperties}
    >
      <svg width={GLYPH[size]} height={GLYPH[size]} viewBox="0 0 24 24" className={cn("shrink-0", dark ? "fill-fg" : "fill-[var(--app)]")}>
        <path d={icon.path} />
      </svg>
    </span>
  );
}
